import { render } from "./column.vue?vue&type=template&id=134b865c&scoped=true"
import script from "./column.vue?vue&type=script&lang=js"
export * from "./column.vue?vue&type=script&lang=js"

import "./column.vue?vue&type=style&index=0&id=134b865c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134b865c"]])

export default __exports__